import React from 'react'

function Icse() {
  return (
    <div>Icse</div>
  )
}

export default Icse